import React from 'react'
import { InjectedFormProps, reduxForm, Field } from 'redux-form'
import { Button, Col, Form, Row } from 'antd'
import { useTranslation } from 'react-i18next'
import { debounce } from 'lodash'
import { PlusOutlined, SearchOutlined } from '@ant-design/icons'

// utils
import { FORM, PROTECTION_INTERVAL_FOR_FILTER } from '../../../utils/enums'
import { validationString } from '../../../utils/helper'

// atoms
import InputField from '../../../atoms/InputField'

type ComponentProps = {
	createNewTemplate?: any
}

interface IUserPermissionFilter {
	search: string
}

type Props = InjectedFormProps<IUserPermissionFilter, ComponentProps> & ComponentProps

const fixLength100 = validationString(100)

const TemplatesPageFilter = (props: Props) => {
	const { handleSubmit, createNewTemplate } = props

	const { t } = useTranslation()

	return (
		<Form layout='horizontal' onSubmitCapture={handleSubmit} className={'pt-0'}>
			<Row className={'flex flex-wrap'}>
				<Col span={4}>
					<Field
						className={'h-10 p-0 m-0'}
						component={InputField as any}
						size={'large'}
						placeholder={t('loc:Search template ...')}
						name='search'
						search
						validate={fixLength100}
						prefix={<SearchOutlined />}
					/>
				</Col>
				<Col span={4} offset={16} className={'pl-5 flex justify-end'}>
					<Button className={'rounded h-10 ml-2 flex items-center'} type='primary' icon={<PlusOutlined />} onClick={createNewTemplate}>
						{t('loc:Create template')}
					</Button>
				</Col>
			</Row>
		</Form>
	)
}

const form = reduxForm<IUserPermissionFilter, ComponentProps>({
	form: FORM.TEMPLATES_PAGE_FILTER,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	onChange: debounce((_values, _dispatch, { submit, anyTouched }) => {
		if (anyTouched) {
			submit()
		}
	}, PROTECTION_INTERVAL_FOR_FILTER),
	destroyOnUnmount: true
})(TemplatesPageFilter)

export default form
